<div class="wrapper">
  
      <textarea id="file-contents" value={{fileContents}} [disabled]="true"></textarea>
  
</div>
